// Mock data for La Pasteria Pizza Bar - Updated from PDF menu

export const restaurantInfo = {
  name: "La Pasteria",
  tagline: "Pizza Bar",
  address: "36 High Street North, Dunstable, LU6 1LA",
  phone: "01582 758636",
  email: "Lapasteriapizzabar@gmail.com",
  tripAdvisorUrl: "https://www.tripadvisor.co.uk/Restaurant_Review-g499476-d28005110-Reviews-La_Pasteria_Pizza_Bar-Dunstable_Bedfordshire_England.html",
  googleReviewsUrl: "https://www.google.com/search?q=La+Pasteria+Pizza+Bar+Reviews"
};

export const openingHours = [
  { day: "Monday", hours: "12:00 - 22:00" },
  { day: "Tuesday", hours: "12:00 - 22:00" },
  { day: "Wednesday", hours: "12:00 - 22:00" },
  { day: "Thursday", hours: "12:00 - 22:00" },
  { day: "Friday", hours: "12:00 - 22:00" },
  { day: "Saturday", hours: "12:00 - 22:00" },
  { day: "Sunday", hours: "12:00 - 21:00" }
];

export const fullMenu = {
  pizza: [
    { name: "Margherita", description: "Tomato base, fior di latte mozzarella, basil & olive oil. White base available on request.", price: "£13.00", vegetarian: true },
    { name: "Pepperoni", description: "Tomato base, fior di latte mozzarella & pepperoni. White base available on request.", price: "£14.50" },
    { name: "Diavola", description: "Tomato base, fior di latte mozzarella, spicy salami, onion, olives & chilli. White base available on request.", price: "£15.00", spicy: true },
    { name: "Piccante", description: "Tomato base, fior di latte mozzarella, pepperoni, spianata & chilli. White base available on request.", price: "£15.50", spicy: true },
    { name: "Frutti di Mare", description: "Tomato base, mixed seafood, rocket & cherry tomatoes. White base available on request.", price: "£19.00" },
    { name: "Pesto Chicken", description: "Pesto base, fior di latte mozzarella, chicken & burrata cheese.", price: "£16.50" },
    { name: "Tonno & Cipolla", description: "Tomato base, fior di latte mozzarella, tuna & red onion. White base available on request.", price: "£15.00" },
    { name: "Parma", description: "Tomato base, fior di latte mozzarella, Parma ham, rocket & shaved parmesan. White base available on request.", price: "£17.00" },
    { name: "Pizza Bolognese", description: "Tomato base, fior di latte mozzarella & homemade beef ragu. White base available on request.", price: "£16.00" },
    { name: "Prosciutto & Burrata", description: "Tomato base, fior di latte mozzarella, Parma ham, fresh burrata & rocket. White base available on request.", price: "£18.00" },
    { name: "Mediterranea", description: "Tomato base, fior di latte mozzarella, feta, olives, peppers, red onion & oregano. White base available on request.", price: "£16.00", vegetarian: true },
    { name: "Vegetariana", description: "Tomato base, fior di latte mozzarella, mushrooms, peppers, courgettes & black olives. White base available on request.", price: "£15.00", vegetarian: true },
    { name: "Capricciosa", description: "Tomato base, fior di latte mozzarella, mushrooms, ham, artichokes & olives. White base available on request.", price: "£16.00" },
    { name: "Quattro Formaggi", description: "Tomato base, fior di latte mozzarella, gorgonzola, scamorza & parmigiano. White base available on request.", price: "£17.00", vegetarian: true },
    { name: "Caprese", description: "White base, fior di latte mozzarella, fresh tomatoes, buffalo mozzarella & basil.", price: "£14.00", vegetarian: true },
    { name: "Ham & Mushroom", description: "Tomato base, fior di latte mozzarella, ham & mushrooms. White base available on request.", price: "£15.50" },
    { name: "Pollo BBQ", description: "BBQ or tomato base, fior di latte mozzarella, chicken, red onion & BBQ drizzle.", price: "£16.00" },
    { name: "La Pasteria Special", description: "Tomato base, fior di latte mozzarella, pepperoni, mushrooms, peppers, onions & olives. White base available on request.", price: "£17.50" },
  ],
  pasta: [
    { name: "Spaghetti Carbonara", description: "Guanciale, eggs, pecorino & parmigiano.", price: "£15.50" },
    { name: "Penne all'Arrabiata", description: "Spicy tomato sauce with chilli, garlic & fresh basil.", price: "£12.50", spicy: true },
    { name: "Pasta al Pesto Genovese", description: "Fresh basil pesto with burrata, parmesan & olive oil.", price: "£15.50" },
    { name: "Spaghetti Bolognese", description: "Ragu sauce (minced beef).", price: "£13.50" },
    { name: "Burrata Pasta", description: "Cherry tomato sauce & burrata cheese.", price: "£14.50" },
    { name: "Lasagne Classica", description: "Oven-baked lasagne with ragu, bechamel & parmesan.", price: "£15.50" },
    { name: "Tagliatelle Alfredo", description: "Creamy sauce with chicken, mushrooms & black pepper.", price: "£15.00" },
    { name: "Penne alla Vodka", description: "Creamy tomato & vodka sauce with parmesan.", price: "£13.50" },
    { name: "Linguine ai Gamberoni", description: "King prawns in tomato sauce with double cream.", price: "£16.00" },
    { name: "Fusilli Primavera", description: "Seasonal vegetables, garlic, olive oil & herbs.", price: "£12.50" },
    { name: "Linguine all Scoglio", description: "Mixed seafood in tomato & double cream sauce.", price: "£18.50" },
  ],
  salads: [
    { name: "La Pasteria", description: "Rocket, parmigiano, dried tomatoes, dried grapes, walnuts, cherry tomatoes, pomegranate & balsamic dressing.", price: "Small £10.50 / Large £16.00", variants: [{ name: "Small", price: "£10.50" }, { name: "Large", price: "£16.00" }] },
    { name: "Caesar", description: "Lettuce, chicken, croutons, parmigiano & Caesar dressing.", price: "£14.50" },
    { name: "Caprese", description: "Tomatoes, buffalo mozzarella, basil & olive oil.", price: "£9.50", vegetarian: true },
    { name: "Rucola & Parmigiano", description: "Rocket, shaved parmigiano & balsamic glaze.", price: "£8.50", vegetarian: true },
    { name: "Insalata Greca", description: "Tomatoes, cucumber, red onion, peppers, olives, feta & oregano.", price: "£12.50", vegetarian: true },
    { name: "Insalata Mista", description: "Mixed lettuce, tomatoes, cucumbers, onions & carrots.", price: "£7.50", vegetarian: true },
    { name: "Il Tricolore", description: "Avocado, buffalo mozzarella, tomatoes, rocket & balsamic glaze.", price: "£10.50", vegetarian: true },
  ],
  risotto: [
    { name: "Risotto Pollo e Funghi", description: "Chicken, mushrooms, parmesan, garlic & white wine.", price: "£14.50" },
    { name: "Risotto ai Gamberoni", description: "King prawns, garlic, parsley, tomato & white wine.", price: "£16.50" },
    { name: "Risotto ai Frutti di Mare", description: "Prawns, mussels, calamari, tomato, parsley & white wine.", price: "£16.50" },
  ],
  antipasti: [
    { name: "Antipasto Italiano", description: "Italian meats & cheeses with grilled bread & olives.", price: "£19.00" },
    { name: "Burrata alla Pugliese", description: "Burrata with cherry tomatoes, rocket & balsamic glaze.", price: "£10.50", vegetarian: true },
    { name: "Grilled Vegetables", description: "Grilled vegetables with garlic, olive oil & balsamic glaze.", price: "£7.50", vegetarian: true },
    { name: "Creamy Cheese Dip", description: "Homemade cheese dip served with bread.", price: "£6.00", vegetarian: true },
    { name: "Tzatziki", description: "Homemade yoghurt dip served with bread.", price: "£6.00", vegetarian: true },
    { name: "La Pasteria Sharing Board", description: "Large selection of Italian cured meats, cheeses, olives & bread perfect to share. (2-3 people)", price: "£28.50" },
    { name: "Feta al Forno", description: "Baked feta with tomatoes, peppers & mozzarella.", price: "£10.00", vegetarian: true },
    { name: "Mixed Olives", description: "Italian marinated olives served with grilled bread.", price: "£5.20", vegetarian: true },
  ],
  tradizionaliItaliani: [
    { name: "Bruschetta Classica", description: "Tomatoes, garlic, basil, oregano & olive oil.", price: "£7.50", vegetarian: true },
    { name: "Melanzane alla Parmigiana", description: "Baked aubergine with tomato, basil & parmesan.", price: "£9.50", vegetarian: true },
    { name: "Marinated Anchovies", description: "Mediterranean-style marinated anchovies.", price: "£6.00" },
    { name: "Bruschetta LP", description: "Tomatoes, garlic, basil, oregano, olive oil & marinated anchovies.", price: "£8.50" },
    { name: "Carpaccio di Bresaola", description: "Cured beef with rocket, lemon & shaved parmesan.", price: "£11.50" },
  ],
  caldiFritti: [
    { name: "Calamari Fritte", description: "Lightly fried squid served with lemon.", price: "£10.50" },
    { name: "Quattro Formaggi Balls", description: "Crispy fried cheese balls served with dip.", price: "£7.50", vegetarian: true },
    { name: "Garlic Bread", description: "Freshly baked garlic bread.", price: "£7.50", vegetarian: true },
    { name: "Patatine Fritte", description: "Golden French fries.", price: "£5.50", vegetarian: true },
    { name: "Breaded Crab Claws", description: "Crispy crab claws served with dip.", price: "£9.50" },
    { name: "Fried Courgette", description: "Crispy fried courgette served with tzatziki.", price: "£5.50", vegetarian: true },
    { name: "Cheesy Garlic Bread", description: "Garlic bread topped with melted mozzarella.", price: "£8.50", vegetarian: true },
  ],
  meatAndFish: [
    { name: "Fresh Fish of the Day", description: "Ask a member of staff. Grilled & served with grilled vegetables. Seabass or Sea Bream.", price: "£26.00", variants: [{ name: "Seabass", price: "£26.00" }, { name: "Sea Bream", price: "£26.00" }] },
    { name: "Grilled Prawns", description: "Served with rocket salad.", price: "£15.00" },
    { name: "Butterfly Prawns", description: "Grilled prawns in garlic sauce served with rocket salad.", price: "£15.50" },
    { name: "Grilled Calamari", description: "Served with rocket salad.", price: "£17.50" },
    { name: "Stuffed Calamari", description: "Grilled calamari stuffed with feta cheese & fresh tomatoes.", price: "£19.50" },
    { name: "T-Bone Steak", description: "Served with chips, rocket & cherry tomatoes.", price: "£32.00" },
    { name: "Frutti di Mare Misto (Sharing)", description: "Fried seafood: sardines, calamari, prawns, crab claws, mussels, anchovies, four formaggi balls, olives & cherry tomatoes.", price: "£28.50" },
    { name: "Frutti di Mare Misto (Single)", description: "Selection of mixed fried seafood for one person.", price: "£19.50" },
    { name: "Baby Lamb Chops", description: "Grilled baby lamb chops served with French fries.", price: "£18.00" },
    { name: "Chicken Breast", description: "Grilled chicken breast served with French fries or vegetables.", price: "£14.50" },
  ],
  kidsMenu: [
    { name: "Margherita Pizza", description: "Tomato sauce & mozzarella.", price: "£7.50", vegetarian: true },
    { name: "Pepperoni Pizza", description: "Tomato sauce, mozzarella & pepperoni.", price: "£8.50" },
    { name: "Penne Bolognese", description: "Penne pasta with slow cooked beef ragu & parmesan.", price: "£7.50" },
    { name: "Ham Pizza", description: "Tomato sauce, mozzarella & ham.", price: "£8.20" },
    { name: "Chicken Nuggets & Chips", description: "Served with ketchup or mayo.", price: "£6.90" },
    { name: "Plain Pasta with Cream & Parmigiano", description: "Pasta tossed in double cream and parmigiano.", price: "£6.00" },
  ],
  softDrinks: [
    { name: "Coca-Cola 330ml", price: "£2.95" },
    { name: "Diet Coca-Cola 330ml", price: "£2.95" },
    { name: "Fanta 330ml", price: "£3.20" },
    { name: "Orange Juice 250ml", price: "£3.40" },
    { name: "Apple Juice 250ml", price: "£3.40" },
    { name: "Sparkling Water 750ml", price: "£3.90" },
    { name: "Mineral Water 750ml", price: "£3.60" },
  ],
  beers: [
    { name: "Draught Peroni", price: "1/2 Pint £4.30 / Pint £6.50" },
    { name: "Budweiser 330ml", price: "£3.20" },
    { name: "Moretti 330ml", price: "£3.80" },
    { name: "Peroni 0%", price: "£3.20" },
  ],
  redWines: [
    { name: "Emporio Nero d'Avola Sicilia", price: "Glass £7.00 / Bottle £28.00" },
    { name: "Cabernet Sauvignon Bio Vegan", price: "Glass £7.50 / Bottle £30.00" },
    { name: "Tirteo Barbera d'Asti", price: "£35.00" },
    { name: "Negroamaro Saleto", price: "£40.00" },
    { name: "Chianti Riserva", price: "£45.00" },
    { name: "Villa Borghetti Valpolicella", price: "£50.00" },
    { name: "Shiraz 187ml", price: "£9.50" },
  ],
  whiteWines: [
    { name: "Previata Pinot Grigio", price: "Glass £7.00 / Bottle £28.00" },
    { name: "Luigi Leonardo Chardonnay", price: "Glass £7.50 / Bottle £30.00" },
    { name: "Poesie Chardonnay Veneto", price: "£35.00" },
    { name: "Terre Nardin Sauvignon", price: "£40.00" },
    { name: "Sauvignon Blanc 187ml", price: "£9.50" },
  ],
  roseWines: [
    { name: "Pinot Grigio Rosato", price: "£35.00" },
    { name: "Jack Rabbit Rosato 187ml", price: "£9.00" },
  ],
  desserts: [
    { name: "Nutella Dough Bits", description: "Topped with crushed walnuts and powdered sugar.", price: "£8.90", vegetarian: true },
    { name: "Tiramisu", description: "Classic Italian tiramisu.", price: "£6.50", vegetarian: true },
    { name: "Pistachio Tiramisu", description: "Tiramisu with a pistachio twist.", price: "£7.50", vegetarian: true },
    { name: "Cheesecake", description: "Creamy cheesecake.", price: "£4.90", vegetarian: true },
    { name: "Lemon Pie", description: "Tangy lemon pie.", price: "£4.90", vegetarian: true },
    { name: "Panna Cotta", description: "Silky Italian panna cotta.", price: "£4.90", vegetarian: true },
  ],
};

export const menuHighlights = [
  { name: "Margherita", description: "Tomato base, fior di latte mozzarella, basil & olive oil.", price: "£13.00", category: "Pizza", vegetarian: true },
  { name: "Spaghetti Carbonara", description: "Guanciale, eggs, pecorino & parmigiano.", price: "£15.50", category: "Pasta" },
  { name: "La Pasteria Special", description: "Tomato base, fior di latte mozzarella, pepperoni, mushrooms, peppers, onions & olives.", price: "£17.50", category: "Pizza" },
  { name: "Risotto ai Gamberoni", description: "King prawns, garlic, parsley, tomato & white wine.", price: "£16.50", category: "Risotto" },
  { name: "T-Bone Steak", description: "Served with chips, rocket & cherry tomatoes.", price: "£32.00", category: "Meat & Fish" },
  { name: "Lasagne Classica", description: "Oven-baked lasagne with ragu, bechamel & parmesan.", price: "£15.50", category: "Pasta" },
];

export const galleryImages = [
  { id: 1, base: "/images/gallery-4", alt: "Seafood Linguine with Mussels" },
  { id: 2, base: "/images/gallery-1", alt: "Cheesy Pasta" },
  { id: 3, base: "/images/gallery-6", alt: "Fresh Bruschetta" },
  { id: 4, base: "/images/gallery-2", alt: "Restaurant Dining" },
  { id: 5, base: "/images/gallery-5", alt: "Table Setting" },
  { id: 6, base: "/images/gallery-3", alt: "Restaurant Interior" },
];

export const testimonials = [
  {
    name: "James T.",
    rating: 5,
    text: "Absolutely fantastic pizza! The Margherita is simple perfection - you can taste the quality of the ingredients. Best Italian in Dunstable by far.",
    date: "March 2024"
  },
  {
    name: "Sarah M.",
    rating: 5,
    text: "We had the La Pasteria sharing board and it was incredible. Great atmosphere and the staff are so welcoming. Will definitely be back!",
    date: "February 2024"
  },
  {
    name: "David L.",
    rating: 5,
    text: "The carbonara is the real deal - none of that cream nonsense. Proper Italian cooking at its finest. The wine selection is excellent too.",
    date: "January 2024"
  }
];
